import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Location, NgIf } from '@angular/common';
import { IconComponent } from '../../atoms/icon/icon.component';

@Component({
  selector: 'app-bread-crumb',
  standalone: true,
  imports: [
    IconComponent,
    NgIf
  ],
  templateUrl: './bread-crumb.component.html',
  styleUrl: './bread-crumb.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class BreadCrumbComponent {

  @Input() showBtnBack?: Boolean;
  constructor(
    private _location: Location
  ) { }

  ngOnInit() {
  }

  backClicked(){
    this._location.back();
  }

}
